import { error as logError, debug as logDebug } from '../utils/logger'
import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'
import { GetUserProfileResponse } from './interfaces/user.interface'

/* 

    const headers = {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    version: currentGlobalVersion,
                    device_key: deviceId,
                    device: JSON.stringify(device_param),
                }
*/
interface PropsGetUserProfile {
    authToken: string
    headersParam?: {
        'Content-Type'?: string
        Authorization?: string
        version?: string
        device_key?: string
        device?: string
    }
    retries?: number
    timeout?: number
}
// export const request_get_user_profile = async ({ authToken, headersParam }: PropsGetUserProfile) => {
//     const URL_GET_USER_PROFILE = apiUrl + '/get_user_profile'
//     try {

//         let headers = {
//             'Content-Type': 'application/json',
//             Authorization: authToken,
//         }

//         if (headersParam) {
//             headers = {
//                 ...headers,
//                 ...headersParam
//             }
//         }

//         const response = await fetch(URL_GET_USER_PROFILE, {
//             method: 'GET',
//             headers: headers,
//         })

//         if (response.ok) {
//             const data: GetUserProfileResponse = await response.json()
//             return data
//         } else {
//             throw new Error('Error al realizar la solicitud request_get_user_profile')
//         }
//     } catch (error) {
//         console.error('request_get_user_profile: =>> ', error)
//     }
// }
export const request_get_user_profile = async ({ authToken, headersParam, retries = 0, timeout = 5 }: PropsGetUserProfile) => {
    const URL_GET_USER_PROFILE = apiUrl + '/get_user_profile'

    try {
        const headers = {
            Authorization: authToken,
            ...headersParam,
        }
        const data = await sendRequest(URL_GET_USER_PROFILE, 'GET', headers, undefined, retries, timeout)
        return data.response
    } catch (error) {
    logError('UserService', 'Error en request_get_user_profile:', error)
        return null
    }
}

export const request_edit_user_profile = async (authToken, attibutesFilter, headersParam) => {
    logDebug('UserService', 'attibutesFilter', attibutesFilter)
    const URL_EDIT_USER_PROFILE = apiUrl + '/edit_user_profile'
    try {
        let headers = {
            'Content-Type': 'application/json',
            authorization: authToken,
        }

        if (headersParam) {
            headers = {
                ...headers,
                ...headersParam,
            }
        }

        const response = await fetch(URL_EDIT_USER_PROFILE, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                user_data: attibutesFilter,
            }),
        })

        if (response.ok) {
            const data = await response.json()
            return data
        } else {
            logDebug('UserService', 'response', response)
            throw new Error('Error al realizar la solicitud request_edit_user_profile')
        }
    } catch (error) {
    logError('UserService', 'request_edit_user_profile failed', error)
    }
}
